import React, { ReactNode, useEffect } from "react";
import { ThemeProvider, useTheme } from "context/ThemeContext";

interface RouteThemeWrapperProps {
  children: ReactNode;
  theme?: "light" | "dark" | null;
}

const ThemeApplier: React.FC<{ forcedTheme?: "light" | "dark"; children: ReactNode }> = ({ forcedTheme, children }) => {
  const { effectiveTheme } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const themeToApply = forcedTheme || effectiveTheme;

    if (themeToApply === "dark") {
      root.classList.add("dark");
      root.setAttribute("data-theme", "dark");
    } else {
      root.classList.remove("dark");
      root.setAttribute("data-theme", "light");
    }
  }, [forcedTheme, effectiveTheme]);

  return <>{children}</>;
};

const RouteThemeWrapper: React.FC<RouteThemeWrapperProps> = ({ children, theme }) => {
  if (theme) {
    return (
      <ThemeProvider forcedTheme={theme}>
        <ThemeApplier forcedTheme={theme}>{children}</ThemeApplier>
      </ThemeProvider>
    );
  }

  return <ThemeApplier>{children}</ThemeApplier>;
};

export default RouteThemeWrapper;
